// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as TestUtils$OrcaPaymentPage from "./Utilities/TestUtils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./Utilities/RecoilAtoms.bs.js";
import * as CardThemeType$OrcaPaymentPage from "./Types/CardThemeType.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "./Utilities/PaymentHelpers.bs.js";
import * as PaymentInputField$OrcaPaymentPage from "./Components/PaymentInputField.bs.js";

function CardCVCElement(props) {
  var paymentType = props.paymentType;
  var cvcProps = props.cvcProps;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = match.config.appearance;
  var keys = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var customPodUri = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.customPodUri);
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var redirectionFlags = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.redirectionFlagsAtom);
  var setCvcError = cvcProps.setCvcError;
  var cvcError = cvcProps.cvcError;
  var cvcNumber = cvcProps.cvcNumber;
  var isCvcEmpty = cvcNumber === "";
  var compressedLayoutStyleForCvcError = match$1.innerLayout === "Compressed" && cvcError.length > 0 ? "!border-l-0" : "";
  React.useEffect((function () {
          var handleRequestCVCConfirm = function (ev) {
            var json = Utils$OrcaPaymentPage.safeParse(ev.data);
            try {
              var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
              var confirmParams = dict["requestCVCConfirm"];
              if (confirmParams === undefined) {
                return ;
              }
              var confirmParamsDict = Utils$OrcaPaymentPage.getDictFromJson(confirmParams);
              var requiresCvv = Utils$OrcaPaymentPage.getBool(confirmParamsDict, "requiresCvv", true);
              if (paymentType !== "CardCVCElement") {
                return ;
              }
              var body = Utils$OrcaPaymentPage.getJsonObjectFromDict(confirmParamsDict, "body");
              var bodyArr = Object.entries(Core__Option.getOr(Core__JSON.Decode.object(body), {}));
              var payload = Utils$OrcaPaymentPage.getJsonFromDict(confirmParamsDict, "payload", null);
              var paymentTypeStr = Utils$OrcaPaymentPage.getString(confirmParamsDict, "paymentType", "card");
              var publishableKeyVal = Utils$OrcaPaymentPage.getString(confirmParamsDict, "publishableKey", keys.publishableKey);
              var clientSecretVal = Utils$OrcaPaymentPage.getString(confirmParamsDict, "clientSecret", Core__Option.getOr(keys.clientSecret, ""));
              var isCvcComplete = cvcNumber.length >= 3;
              if (requiresCvv && isCvcComplete) {
                setCvcError(function (param) {
                      return "";
                    });
                var bodyWithCvc = bodyArr.concat([[
                        "card_cvc",
                        cvcNumber
                      ]]);
                var paymentType$1 = PaymentHelpers$OrcaPaymentPage.getPaymentType(paymentTypeStr);
                Core__Promise.$$catch(PaymentHelpers$OrcaPaymentPage.paymentIntentForPaymentSession(bodyWithCvc, paymentType$1, payload, publishableKeyVal, clientSecretVal, loggerState, customPodUri, redirectionFlags, undefined, "CardCVCElement").then(function (response) {
                          Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                                  "cvcWidgetConfirmResponse",
                                  response
                                ]]);
                          return Promise.resolve();
                        }), (function (err) {
                        Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                                "cvcWidgetConfirmErrorResponse",
                                JSON.stringify(Utils$OrcaPaymentPage.formatException(err))
                              ]]);
                        return Promise.resolve();
                      }));
                return ;
              }
              if (!requiresCvv) {
                return Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                              "cvcWidgetConfirmErrorResponse",
                              Utils$OrcaPaymentPage.handleFailureResponse("Something went wrong", "cvc_validation_failed")
                            ]]);
              }
              var isEmptyCVC = cvcNumber.length === 0;
              var errorMsg = isEmptyCVC ? localeString.cvcNumberEmptyText : localeString.inCompleteCVCErrorText;
              setCvcError(function (param) {
                    return errorMsg;
                  });
              return Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                            "cvcWidgetConfirmErrorResponse",
                            Utils$OrcaPaymentPage.handleFailureResponse(errorMsg, "cvc_validation_failed")
                          ]]);
            }
            catch (exn){
              return Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                            "cvcWidgetConfirmErrorResponse",
                            Utils$OrcaPaymentPage.handleFailureResponse("Something went wrong", "cvc_validation_failed")
                          ]]);
            }
          };
          window.addEventListener("message", handleRequestCVCConfirm);
          return (function () {
                    window.removeEventListener("message", handleRequestCVCConfirm);
                  });
        }), [cvcNumber]);
  React.useEffect((function () {
          Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                [
                  "ready",
                  true
                ],
                [
                  "elementType",
                  CardThemeType$OrcaPaymentPage.getPaymentModeToString(paymentType)
                ]
              ]);
        }), []);
  React.useEffect((function () {
          var cvcInfoDict = Object.fromEntries([[
                  "isCvcEmpty",
                  isCvcEmpty
                ]]);
          Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                  "cvcInfo",
                  cvcInfoDict
                ]]);
        }), [isCvcEmpty]);
  return React.createElement(PaymentInputField$OrcaPaymentPage.make, {
              isValid: Caml_option.some(cvcProps.isCVCValid),
              setIsValid: cvcProps.setIsCVCValid,
              value: cvcNumber,
              onChange: cvcProps.changeCVCNumber,
              onBlur: cvcProps.handleCVCBlur,
              errorString: cvcError,
              fieldName: localeString.cvcTextLabel,
              name: TestUtils$OrcaPaymentPage.cardCVVInputTestId,
              type_: "tel",
              maxLength: 4,
              placeholder: "123",
              className: "tracking-widest w-full " + compressedLayoutStyleForCvcError,
              inputRef: cvcProps.cvcRef,
              autocomplete: "cc-csc"
            });
}

var make = CardCVCElement;

export {
  make ,
}
/* react Not a pure module */
